import { Injectable } from '@angular/core';
import { IDatiqAnalyticsEventInputInfo } from '@dat/datiq-core/models';
import { Store } from '@ngrx/store';
import { IDatiqButton } from '../models';
import { DatiqButtonActions } from '../store';
import { DatiqButtonMapperService } from './datiq-button-mapper.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqButtonEventsService {
    constructor(
        private _store: Store,
        private _mapper: DatiqButtonMapperService
    ) {}

    click(settings: IDatiqButton): void {
        this._store.dispatch(
            DatiqButtonActions.click({
                eventName: DatiqButtonActions.clickName,
                inputInfo: this._mapper.mapClickInputInfo(settings),
            })
        );
    }
}
